import { DEFAULT_PROTECTED_ROUTE_PATH } from "@/constants/routes";
import { useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { ProfilePageView } from "./ProfilePageView";
import { useProfileActiveTab } from "./useProfileActiveTab";

export const ProfilePage = () => {
  const { activeTab, setActiveTab } = useProfileActiveTab();
  const navigate = useNavigate();
  const location = useLocation();

  // react-router only stamps the very first history entry with key "default" (e.g. a deep
  // link or hard refresh on /profile). Read once at mount: switching tabs replaces the
  // entry with a freshly keyed one without adding history, which would otherwise make a
  // deep-linked page look navigable-back.
  const isFirstHistoryEntry = useRef(location.key === "default").current;

  const handleBack = useCallback(() => {
    if (isFirstHistoryEntry) {
      navigate(DEFAULT_PROTECTED_ROUTE_PATH);
      return;
    }
    navigate(-1);
  }, [isFirstHistoryEntry, navigate]);

  return <ProfilePageView activeTab={activeTab} onTabChange={setActiveTab} onBack={handleBack} />;
};
